// Vallitas constants
export const WHATSAPP_NUMBER = "584143581962";

export const buildWhatsAppLink = (message) => {
  const text = encodeURIComponent(message || "Hola Vallitas, quiero personalizar mi prenda.");
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
};

export const SOCIALS = {
  instagram: "https://instagram.com/vallitasve",
  tiktok: "https://tiktok.com/@vallitasve",
};

// Catalog (Google Drive shareable link)
export const CATALOG_URL =
  "https://drive.google.com/file/d/1MV5olX70lzurfnZ7icL68l-B67NfX-F7/view?usp=sharing";

// Shop categories (Tienda)
export const SHOP_CATEGORIES = [
  { slug: "bodys", name: "Bodys" },
  { slug: "jerseys", name: "Jerseys manga larga" },
  { slug: "deportiva", name: "Ropa deportiva" },
  { slug: "trajes-bano", name: "Trajes de baño" },
  { slug: "vestidos", name: "Vestidos" },
  { slug: "pantalones", name: "Pantalones" },
  { slug: "accesorios", name: "Accesorios" },
];

export const SHOP_GENDERS = [
  { slug: "mujer", name: "Mujer" },
  { slug: "hombre", name: "Hombre" },
  { slug: "unisex", name: "Unisex" },
];

// Real photographic image library curated for the brand
export const IMAGES = {
  hero: "/brand/naiderly.jpeg",
  heroSecondary: "https://images.unsplash.com/photo-1518310383802-640c2de311b2?auto=format&fit=crop&w=1200&q=80",
  valueProposition: "https://images.unsplash.com/photo-1564245774490-70edab3c3f6b?auto=format&fit=crop&w=1200&q=80",
  productBody: "https://images.pexels.com/photos/29720699/pexels-photo-29720699.jpeg",
  productJersey: "https://images.unsplash.com/photo-1556906781-9a412961c28c?auto=format&fit=crop&w=1200&q=80",
  productSport: "https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=1200&q=80",
  brandStory: "https://images.pexels.com/photos/6280118/pexels-photo-6280118.jpeg",
  b2b: "https://images.pexels.com/photos/9501972/pexels-photo-9501972.jpeg",
  testimonial1: "https://images.unsplash.com/photo-1517438476312-10d79c077509?auto=format&fit=crop&w=800&q=80",
  testimonial2: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=800&q=80",
  testimonial3: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=800&q=80",
  testimonial4: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=800&q=80",
  detailFabric: "https://images.pexels.com/photos/6311474/pexels-photo-6311474.jpeg?auto=compress&cs=tinysrgb&w=1000",
  detailHands: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?auto=format&fit=crop&w=1000&q=80",
};

export const PRODUCTS = [
  {
    id: "bodys",
    name: "Bodys",
    description: "Piezas femeninas de fit perfecto, listas para personalizar con tu nombre o logo.",
    image: "/bodys/rosa.jpeg",
    tags: ["Mujer", "Personalizable", "Moderno"],
  },
  {
    id: "jerseys",
    name: "Jerseys",
    description: "Para entrenar, viajar o lucir un diseño que cuente tu historia. Sublimación full color.",
    image: "/jerseys/jersey-1.jpeg",
    tags: ["Unisex", "Sublimación", "Manga larga"],
  },
  {
    id: "deportiva",
    name: "Ropa deportiva",
    description: "Conjuntos, leggings y tops para gym, playa o running. Tejidos transpirables y elásticos.",
    image: IMAGES.productSport,
    tags: ["Activewear", "Equipos", "Bajo pedido"],
  },
];

export const COLORS = [
  { slug: "vinotinto", name: "Vinotinto", hex: "#722F37" },
  { slug: "negro", name: "Negro", hex: "#1B1416" },
  { slug: "blanco", name: "Blanco", hex: "#F4EFE8" },
  { slug: "beige", name: "Beige", hex: "#D7C2AC" },
  { slug: "rosa-palo", name: "Rosa palo", hex: "#D9A9A2" },
  { slug: "verde-militar", name: "Verde militar", hex: "#4A5240" },
  { slug: "azul-marino", name: "Azul marino", hex: "#1F2A44" },
  { slug: "gris-perla", name: "Gris perla", hex: "#9A9590" },
];

export const SIZES = ["XS", "S", "M", "L", "XL", "2XL"];

export const BODY_MODELS = [
  {
    slug: "orquidea",
    name: "Orquídea",
    image: "/bodys/orquidea.jpeg",
    gallery: [
      "/bodys/orquidea.jpeg",
      "/bodys/orquidea-2.jpeg",
      "/bodys/orquidea-3.jpeg"
    ],
    tagline: "Asimétrico · Sensual",
    description:
      "Cuello halter de un solo hombro, líneas que esculpen y un escote pensado para quienes no piden permiso.",
    longDescription:
      "El Orquídea juega con la asimetría como protagonista: un solo hombro descubierto, escote halter alto y un fit que sigue cada movimiento. Confeccionado en suplex premium con triple costura, ofrece una caída fluida sin perder estructura. Es el body que se lleva con jeans en la tarde y con falda midi cuando la noche te invita.",
    fabric: "Suplex premium · 88% poliéster · 12% spandex",
    care: "Lavar a mano o ciclo delicado en agua fría. No usar secadora.",
    fit: "Slim fit moldeador. Recomendamos talla habitual.",
    features: ["Halter asimétrico", "Tela suplex premium", "Slim fit moldeador"],
  },
  {
    slug: "dahlia",
    name: "Dahlia",
    image: "/bodys/dahlia.jpeg",
    gallery: [
      "/bodys/dahlia.jpeg",
      "/bodys/dahlia-2.jpeg",
      "/bodys/dahlia-3.jpeg"
    ],
    tagline: "Clásico · Versátil",
    description:
      "Tirantes anchos y escote redondo profundo. El básico que combina con jeans, faldas y todas tus historias.",
    longDescription:
      "El Dahlia es el body que toda mujer debe tener: tirantes amplios para mayor comodidad, escote redondo bajo y una espalda igualmente abierta que estiliza. Pensado para acompañarte de día con un blazer y de noche con una falda satinada.",
    fabric: "Algodón con elastano · 92% algodón · 8% spandex",
    care: "Lavado en máquina ciclo delicado. Planchar al revés.",
    fit: "Regular fit. Crece bien con la silueta.",
    features: ["Escote redondo", "Tirantes 3 cm", "Algodón con elastano"],
  },
  {
    slug: "rosa",
    name: "Rosa",
    image: "/bodys/rosa.jpeg",
    gallery: [
      "/bodys/rosa.jpeg",
      "/bodys/rosa-2.jpeg",
      "/bodys/rosa-3.jpeg"
    ],
    tagline: "Cuadrado · Empoderador",
    description:
      "Escote cuadrado, hombros marcados y un acabado que abraza la silueta. Para sentirte poderosa de día y de noche.",
    longDescription:
      "El Rosa redefine el básico con un escote cuadrado limpio y hombros estructurados que potencian la postura. Su tela con acabado satinado mate refleja la luz justa para destacar sin gritar. Diseñado para mujeres que entran a un lugar y se nota.",
    fabric: "Modal con elastano · 70% modal · 25% poliéster · 5% spandex",
    care: "Lavar en frío con prendas similares. Secar a la sombra.",
    fit: "Slim fit. Ajusta sin apretar.",
    features: ["Escote cuadrado", "Body alto", "Acabado satinado mate"],
  },
  {
    slug: "lirio",
    name: "Lirio",
    image: "/bodys/lirio.jpeg",
    gallery: [
      "/bodys/lirio.jpeg",
      "/bodys/lirio-2.jpeg",
      "/bodys/lirio-3.jpeg",
      "/bodys/lirio-4.jpeg",
    ],
    tagline: "Profundo · Elegante",
    description:
      "Escote en V profundo y caída suave. Inspirado en quienes llevan elegancia hasta en los pequeños detalles.",
    longDescription:
      "El Lirio es elegancia pura: escote en V profundo al frente y a la espalda, tirantes amplios que estilizan los hombros y una caída fluida que abraza la cintura. Su tela sedosa al tacto se siente como un susurro. Perfecto para una cena, una boda o una noche en la que quieras ser tú la flor.",
    fabric: "Microfibra sedosa · 90% poliamida · 10% elastano",
    care: "Lavado a mano recomendado. No retorcer.",
    fit: "Slim fit con caída fluida. Talla habitual.",
    features: ["Escote en V doble", "Tirantes amplios", "Tela fluida sedosa"],
  },
  {
    slug: "margarita",
    name: "Margarita",
    image: "/bodys/margarita.jpeg",
    gallery: [
      "/bodys/margarita.jpeg",
      "/bodys/margarita-2.jpeg"
    ],
    tagline: "Fresco · Cotidiano",
    description:
      "Manga corta, cuello redondo, fit relajado. El body camiseta que se siente como tu segunda piel.",
    longDescription:
      "El Margarita es el body camiseta para todos los días: manga corta, cuello redondo cómodo y un fit relajado pero femenino. La tela es ultra suave y respira con calor o frío. Es ese básico al que vuelves todas las semanas, el que combina con todo y nunca falla.",
    fabric: "Algodón pima con elastano · 95% algodón pima · 5% spandex",
    care: "Lavado en máquina. Soporta planchado a temperatura media.",
    fit: "Regular fit con caída suave.",
    features: ["Manga corta", "Cuello redondo", "Tela fresca y ligera"],
  },
  {
    slug: "gardenia",
    name: "Gardenia",
    image: "/bodys/gardenia.jpeg",
    gallery: [
      "/bodys/gardenia.jpeg",
      "/bodys/gardenia-2.jpeg",
      "/bodys/gardenia-3.jpeg"
    ],
    tagline: "Atemporal · Sutil",
    hideFromGallery: true,
    description:
      "Tirantes anchos y escote U suave. El body que sienta perfecto sin esfuerzo, día tras día.",
    longDescription:
      "El Gardenia es la elegancia silenciosa: tirantes amplios que respetan el sostén, escote U abierto y caída limpia que no se arruga. Pensado para quien valora los básicos bien hechos. Funciona con jeans claros, blazer oversize o falda lápiz — siempre con un aire intencional.",
    fabric: "Algodón pima con elastano · 92% algodón · 8% spandex",
    care: "Lavar a máquina ciclo delicado en frío. Secar a la sombra.",
    fit: "Regular fit que respeta la silueta natural.",
    features: ["Escote U", "Tirantes anchos", "Algodón pima"],
  },
  {
    slug: "camelia",
    name: "Camelia",
    image: "/bodys/camelia.jpeg",
    gallery: [
      "/bodys/camelia.jpeg",
      "/bodys/camelia-2.jpeg",
      "/bodys/camelia-3.jpeg"
    ],
    tagline: "Refinado · Coqueto",
    hideFromGallery: true,
    description:
      "Escote cuadrado y manga corta. Un toque femenino y refinado, sin perder comodidad.",
    longDescription:
      "El Camelia une dos clásicos en una sola pieza: el escote cuadrado que estiliza el cuello y la manga corta estructurada que define los hombros. La tela tiene caída suave y un acabado mate que favorece toda piel. Es el body para esos almuerzos largos, citas y reuniones donde quieres lucir intencional sin parecer arreglada.",
    fabric: "Modal con elastano · 75% modal · 20% poliéster · 5% spandex",
    care: "Lavar en frío con prendas similares. No usar blanqueador.",
    fit: "Slim fit. Acompaña la silueta sin apretar.",
    features: ["Escote cuadrado", "Manga corta", "Modal premium"],
  },
  {
    slug: "lavanda",
    name: "Lavanda",
    image: "/bodys/lavanda.jpeg",
    gallery: [
      "/bodys/lavanda.jpeg",
      "/bodys/lavanda-2.jpeg",
      "/bodys/lavanda-3.jpeg"
    ],
    tagline: "Sereno · Cálido",
    hideFromGallery: true,
    description:
      "Manga larga y cuello redondo clásico. El abrazo de tela que te acompaña en cualquier estación.",
    longDescription:
      "El Lavanda es la calidez hecha prenda: manga larga ajustada, cuello redondo limpio y una tela que se adapta a tu cuerpo sin marcar de más. Perfecto bajo un blazer en otoño o solo con jeans en una noche fresca. Un básico tan versátil que vas a quererlo en varios colores.",
    fabric: "Microfibra con elastano · 88% poliéster · 12% spandex",
    care: "Lavado a máquina ciclo delicado. Planchar a temperatura baja.",
    fit: "Slim fit. Ajuste suave en torso y mangas.",
    features: ["Manga larga", "Cuello redondo", "Tela cálida"],
  },
  {
    slug: "peonia",
    name: "Peonía",
    image: "/bodys/peonia.jpeg",
    gallery: [
      "/bodys/peonia.jpeg",
      "/bodys/peonia-2.jpeg",
      "/bodys/peonia-3.jpeg"
    ],
    tagline: "Definido · Sofisticado",
    hideFromGallery: true,
    description:
      "Escote cuadrado con manga larga. Estructura, sofisticación y una silueta inolvidable.",
    longDescription:
      "El Peonía combina lo mejor de dos mundos: el dramatismo del escote cuadrado y la calidez de la manga larga. Su tela con caída fluida sigue cada movimiento y el escote bien definido enmarca clavículas y rostro. Es el body para esas ocasiones donde quieres ser la última en irse — y la primera en quedarse en la memoria.",
    fabric: "Microfibra sedosa · 90% poliamida · 10% elastano",
    care: "Lavar a mano. No retorcer ni usar secadora.",
    fit: "Slim fit con caída sofisticada.",
    features: ["Escote cuadrado", "Manga larga", "Tela fluida"],
  },
];

export const TESTIMONIALS = [
  {
    name: "Andreína Salazar",
    role: "Cliente, Margarita",
    quote:
      "Mandé a hacer los uniformes de cumpleaños de mi hija y lloré cuando los vi. Calidad, amor y detalles que no se ven en cualquier marca.",
    image: IMAGES.testimonial1,
  },
  {
    name: "Génesis Rojas",
    role: "Madre, Caracas",
    quote:
      "Vallitas me hizo unos bodys con el nombre de mis tres niñas. La fe que ellas le ponen se siente en cada costura. Ya soy cliente fija.",
    image: IMAGES.testimonial2,
  },
  {
    name: "Equipo Voley Pampatar",
    role: "Equipo deportivo",
    quote:
      "Pedimos los jerseys para el torneo y todos los equipos preguntaron quién los hizo. Profesionales, puntuales y con un acabado increíble.",
    image: IMAGES.testimonial3,
  },
  {
    name: "Karelys Mata",
    role: "Cliente, Valencia",
    quote:
      "Mandé un diseño con la Virgen del Valle. No es solo una prenda, es algo que llevo con orgullo. Gracias Naiderly por tanto detalle.",
    image: IMAGES.testimonial4,
  },
];


// Shop products — bodys reuse real photos, others are placeholders until uploaded
export const SHOP_PRODUCTS = [
  // BODYS (real)
  ...BODY_MODELS.map((m) => ({
    id: `body-${m.slug}`,
    name: `Body ${m.name}`,
    image: m.image,
    category: "bodys",
    gender: "mujer",
    tagline: m.tagline,
    href: `/bodys/${m.slug}`,
    badge: "Disponible",
  })),
  // JERSEYS
  {
    id: "jersey-clasico",
    name: "Jersey Clásico",
    image: IMAGES.productJersey,
    category: "jerseys",
    gender: "unisex",
    tagline: "Manga larga · Sublimación",
    badge: "Bajo pedido",
  },
  {
    id: "jersey-equipo",
    name: "Jersey de Equipo",
    image: "https://images.pexels.com/photos/9501972/pexels-photo-9501972.jpeg?auto=compress&cs=tinysrgb&w=1000",
    category: "jerseys",
    gender: "unisex",
    tagline: "Personalizable · Equipos",
    badge: "B2B",
  },
  // DEPORTIVA
  {
    id: "deportiva-conjunto",
    name: "Conjunto deportivo",
    image: IMAGES.productSport,
    category: "deportiva",
    gender: "mujer",
    tagline: "Top + leggings · Activewear",
    badge: "Activewear",
  },
  {
    id: "deportiva-short",
    name: "Short de entrenamiento",
    image: "https://images.pexels.com/photos/4498152/pexels-photo-4498152.jpeg?auto=compress&cs=tinysrgb&w=1000",
    category: "deportiva",
    gender: "hombre",
    tagline: "Transpirable · Running",
    badge: "Hombre",
  },
  // TRAJES DE BAÑO
  {
    id: "bano-bikini",
    name: "Bikini Costa",
    image: "https://images.pexels.com/photos/1144829/pexels-photo-1144829.jpeg?auto=compress&cs=tinysrgb&w=1000",
    category: "trajes-bano",
    gender: "mujer",
    tagline: "Verano · Personalizable",
    badge: "Pronto",
  },
  {
    id: "bano-enterizo",
    name: "Enterizo Solera",
    image: "https://images.pexels.com/photos/1342609/pexels-photo-1342609.jpeg?auto=compress&cs=tinysrgb&w=1000",
    category: "trajes-bano",
    gender: "mujer",
    tagline: "Lycra premium · Talle alto",
    badge: "Pronto",
  },
  // VESTIDOS
  {
    id: "vestido-margarita",
    name: "Vestido Margarita",
    image: "https://images.pexels.com/photos/2738792/pexels-photo-2738792.jpeg?auto=compress&cs=tinysrgb&w=1000",
    category: "vestidos",
    gender: "mujer",
    tagline: "Casual · Día a día",
    badge: "Pronto",
  },
  {
    id: "vestido-lirio",
    name: "Vestido Lirio",
    image: "https://images.pexels.com/photos/1755385/pexels-photo-1755385.jpeg?auto=compress&cs=tinysrgb&w=1000",
    category: "vestidos",
    gender: "mujer",
    tagline: "Elegante · Eventos",
    badge: "Pronto",
  },
  // PANTALONES
  {
    id: "pantalon-recto",
    name: "Pantalón recto",
    image: "https://images.pexels.com/photos/52518/jeans-pants-blue-shop-52518.jpeg?auto=compress&cs=tinysrgb&w=1000",
    category: "pantalones",
    gender: "unisex",
    tagline: "Corte clásico · Atemporal",
    badge: "Pronto",
  },
  {
    id: "pantalon-jogger",
    name: "Pantalón jogger",
    image: "https://images.pexels.com/photos/4066293/pexels-photo-4066293.jpeg?auto=compress&cs=tinysrgb&w=1000",
    category: "pantalones",
    gender: "hombre",
    tagline: "Deportivo · Cómodo",
    badge: "Pronto",
  },
  // ACCESORIOS
  {
    id: "accesorio-gorra",
    name: "Gorra Vallitas",
    image: "https://images.pexels.com/photos/1124465/pexels-photo-1124465.jpeg?auto=compress&cs=tinysrgb&w=1000",
    category: "accesorios",
    gender: "unisex",
    tagline: "Bordado a la medida",
    badge: "Pronto",
  },
  {
    id: "accesorio-tote",
    name: "Tote bag bordado",
    image: "https://images.pexels.com/photos/1152077/pexels-photo-1152077.jpeg?auto=compress&cs=tinysrgb&w=1000",
    category: "accesorios",
    gender: "unisex",
    tagline: "Algodón crudo · Personalizable",
    badge: "Pronto",
  },
];
